// extracted by mini-css-extract-plugin
module.exports = {"root":"SensorInfoContainer_root__ZpF4a","empty":"SensorInfoContainer_empty__1HXFh"};